import { useEffect, useState } from 'react'
import Date from '../../../../Core/Fields/Floating/Date';
import Input from '../../../../Core/Fields/Floating/Input';
import SelectInput from '../../../../Core/Fields/SelectInput';
import Checkbox from '../../../../Core/Fields/Floating/Checkbox';
import Textarea from '../../../../Core/Fields/Floating/Textarea';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';
import Table from './Table';
import ActivityCard from '../../../../Core/Activity/ActivityCard';
import { useGetTaxcategoryQuery, useGetAllcompanyQuery } from '../../../../store/api/Salestaxes';

const Tab1 = ({ formdata, setformdata, handlechange, setTaxes,taxes ,detaildata ,purchaseId,onInputChange }) => {
  const [selected_item_data, setselected_item_data] = useState([]);
    const [taxoptions, setTaxoptions] = useState([])
    const [companyoptions, setCompanyoptions] = useState([])
    const { data: taxCat, isError, isLoading } = useGetTaxcategoryQuery()
    const { data: companydata } = useGetAllcompanyQuery()

    useEffect(() => {
        if (taxCat?.data?.length) {
            setTaxoptions(taxCat.data)
        }
    }, [taxCat])
    useEffect(() => {
        if (companydata?.data?.length) {
            setCompanyoptions(companydata.data)
        }
    }, [companydata])



    const [selectedCompany, setSelectedCompany] = useState('')

    return (
         <div>
            <div className="px-4 py-4" style={{ background: 'white' }}>

                <div className="mb-3" style={{ display: 'flex', gap: '20px' }} >

                    <div className="col-md-12">
                        <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>

                            <div style={{ display: 'flex', gap: '15px', marginBottom: '-10px' }}>
                                <div style={{ flex: 1 }}>
                                    <p className='' style={{ fontSize: '16px', fontWeight: '600', marginLeft: '2px' }}>Details</p>
                                </div>
                            </div>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                    <Input
                                        label="Title"
                                        value={formdata.title}
                                        style={{ height: "30px" }}
                                        readOnly
                                    />
                                </div>
                                <div style={{ flex: 1 }}>
                                     <Input
                                        label="Tax Category"
                                        value={formdata.taxcategory}
                                        style={{ height: "30px" }}
                                        readOnly
                                    />
                                    

                                </div>


                                <div style={{ flex: 1 }}>
<Input
                                        label="Company"
                                        value={formdata.company}
                                        style={{ height: "30px" }}
                                        readOnly
                                    />
                                    
                                </div>

                                <div style={{ flex: 1 }}>
                                    <label style={{ height: '19px' }}></label>

                                    <Checkbox
                                        id="Default"
                                        label="Default"
                                        checked={true}
                                        value={formdata.default || false}
                                        disabled={true}
                                    />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <label style={{ height: '19px' }}></label>
                                    <Checkbox
                                        id="Disabled"
                                        label="Disabled"
                                        checked={true}
                                        value={formdata.disabled || false}
                                        disabled={true}
                                    />

                                </div>

                            </div>







                        </div>
                    </div>

                </div>


                <div className="mb-3" style={{ display: 'flex', gap: '20px', border: '1px solid #DBDBDB', borderRadius: '5px' }} >

                    <div className="col-md-12">
                        <div className='' style={{ height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                    <p className='' style={{ fontSize: '16px', fontWeight: '600' }}>Taxes and Charges</p>
                                </div>
                            </div>

                            <Table   taxes={taxes} setTaxes={setTaxes} detaildata={detaildata}     />



                        </div>
                    </div>

                </div>

                <div className="mb-3" style={{ display: 'flex', gap: '20px' }} >

                    <div className="col-md-12">
                        <div className='' style={{ height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                            <ActivityCard doctype="Purchase Taxes and Charges Template" docname={purchaseId} />
                        </div>
                    </div>
                </div>


            </div>
        </div>
    )
}

export default Tab1